import styled from 'styled-components';

import { BasicParagraph, SmallTitle, style } from '@genially/design-system';

export const DescriptionWrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: size.units(1.5),

  ...style.mixins.responsive.xs.downward({
    gap: size.units(1),
    width: '100%',
  }),
}));

export const Wrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: size.units(3),
  height: '100%',

  [DescriptionWrapper]: {
    flex: 1,
    minWidth: 0,
  },

  ...style.mixins.responsive.xs.downward({
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: size.units(2),
  }),
}));

export const GeniallyThumbnail = styled.img(({ theme: { borderRadius, color } }) => ({
  height: '100%',
  borderRadius: borderRadius.medium,
  border: `1px solid ${color.border.tertiary.default()}`,
  objectFit: 'contain',

  ...style.mixins.responsive.xs.downward({
    width: '100%',
    aspectRatio: '16 / 9',
    height: 'auto',
  }),
}));

export const StyledSmallTitle = styled(SmallTitle)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
}));

export const StyledBasicParagraph = styled(BasicParagraph)(({ theme: { color } }) => ({
  color: color.content.reversed.disabled(),

  ...style.mixins.ellipsis(true),
}));
